export default function StepGuide() {
  const steps = [
    {
      number: '01',
      title: '電話診療の予約',
      description: '公式LINE追加後、「電話診療予約」ボタンからご都合の良い日時をお選びください。',
      time: '所要時間：3分',
      image: 'https://public.readdy.ai/ai/img_res/edited_5245285ecdef063a02d441d55fbd8dce_e3721466.jpg'
    },
    {
      number: '02',
      title: '口腔内写真・身分証のご提出',
      description: '公式LINEのチャットにて、口腔内の写真と身分証をご提出いただきます。スマートフォンで撮影してそのまま送信するだけで簡単に完了します。',
      time: '所要時間：5分',
      image: 'https://public.readdy.ai/ai/img_res/e4ea0bb56575df8ed60a1fc9fb1cd5b9.jpg'
    },
    {
      number: '03',
      title: '歯科医師による診察',
      description: '予約日時になりましたら歯科医師より電話診療を実施致します。現在の歯の状態、施術間隔や施術時の注意事項など、丁寧に診療を行います。',
      time: '所要時間：10分',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/87bfd1c0815bb432828baf1dd930ced5.jpeg'
    },
    {
      number: '04',
      title: '商品到着・使用開始',
      description: '診察後、2〜3日でご自宅にホワイトニングシートがご自宅に届きます。使用方法に従って、1回30分のケアを開始してください。',
      time: '配送：2-3日',
      image: 'https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/0abc85017603ddc4d4af3f1d2e1871f6.jpeg'
    }
  ];

  return (
    <section id="steps" className="py-20 bg-[#F8FBFD]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">ご利用の流れ</h2>
          <p className="text-lg text-gray-600">電話診療から使用開始まで、たった4ステップ</p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div key={index}>
              <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="grid md:grid-cols-5 gap-0">
                  <div className="md:col-span-2 relative h-64 md:h-auto">
                    <>
                      <img 
                        src={step.image} 
                        alt={step.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-4 left-4 px-4 py-2 bg-[#4A90E2] text-white text-sm font-bold rounded-full">
                        STEP {step.number}
                      </div>
                    </>
                  </div>
                  
                  <div className="md:col-span-3 p-8 md:p-12 flex flex-col justify-center">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                    <p className="text-base text-gray-600 leading-relaxed mb-6">
                      {step.description}
                    </p>
                    <span className="inline-block px-4 py-2 bg-[#E3F2FD] text-[#2C5AA0] text-sm font-semibold rounded-full w-fit">
                      {step.time}
                    </span>
                  </div>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flex justify-center py-6">
                  <div className="w-0.5 h-12 bg-gradient-to-b from-[#4A90E2] to-transparent relative">
                    <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-8 border-l-transparent border-r-transparent border-t-[#4A90E2]"></div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}